<template>
  <v-container id="subscriptionForm" class="subscriptionFormContainer px-10">
    <v-layout text-center wrap>
      <v-flex xs12 class="pt-10 text-left">
        <h1>Subscription</h1>
        <v-divider class="mt-4 mb-8"></v-divider>
        <p>
          Please fill out the form below and choose which newsletters you'd like
          to subscribe to.
        </p>
        <v-form v-model="valid">
          <v-text-field v-model="name" :rules="rules" outlined label="Name" required></v-text-field>
          <v-text-field v-model="email" :rules="emailRules" outlined label="Email Address" required></v-text-field>
          <div v-for="brand in brands" :key="brand.projectId">
            <v-row>
              <v-col cols="1">
                <div class="pl-4">
                  <v-checkbox v-model="brand.isSelected"></v-checkbox>
                </div>
              </v-col>
              <v-col cols="11">
                <div class="my-3 px-8">
                  <h2 class="mb-3">{{ brand.name }}</h2>
                  <div>
                    {{ brand.description }} |
                    <a :href="brand.website">Website</a>
                  </div>
                  <v-divider class="mt-4 mb-2"></v-divider>
                  <div class="font-weight-bold mt-3">
                    Days published:
                    <v-chip
                      v-for="day in brand.frequency"
                      :key="day.short"
                      color="primary"
                      dark
                      small
                      class="ml-2"
                    >{{ day.short }}</v-chip>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </div>
          <v-btn
            class="mt-10"
            color="primary"
            :disabled="!valid || !hasSelectedBrands"
            @click="requestSubscription"
          >Subscribe</v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import Vue from "vue";

export default {
  name: "SubscriptionForm",
  computed: {
    hasSelectedBrands() {
      return this.brands.find(brand => {
        return brand.isSelected;
      });
    },
    selectedBrand() {
      return `${this.$route.query.brand}`.toLowerCase();
    },
  },
  async created() {
    await this.getBrands();
    this.brands.forEach(brand => {
      if (brand.shortname === this.selectedBrand) {
        Vue.set(brand, "isSelected", true);
      }
      return brand;
    });
  },
  data() {
    return {
      brands: [],
      name: "",
      email: "",
      emailRules: [
        v => !!v || "Required field",
        v => (!!v && /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*$/i.test(v)) || "Invalid email address format"
      ],
      rules: [v => !!v || "Required field"],
      valid: true,
    };
  },
  methods: {
    async getBrands() {
      const results = await axios({
        url: "/api/brands",
        method: "get",
      });
      this.brands = results.data;
    },
    async requestSubscription() {
      const brands = this.brands
        .filter(brand => brand.isSelected)
        .map(brand => brand.projectId);

      try {
        await axios({
          url: "/api/subscribe",
          method: "post",
          data: {
            email: this.email.trim(),
            name: this.name.trim(),
            brands,
          },
        });
        this.$router.push({ name: "pendingConfirmation" });
      } catch(e) {
        this.$notifyError({ message: "There was an error processing your subscription. Please try again in a few minutes."});
      }      
    },
  },
};
</script>
<style>
.v-input__slot {
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}

.subscriptionFormContainer {
  max-width: 800px;
}
</style>
